var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.248,
    height: 11.248,
    viewBox: "0 0 11.248 11.248",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-sort-alpha-up-alt",
    "data-name": "Icon awesome-sort-alpha-up-alt",
    d: "M.4,5.464H1.607V13.1a.4.4,0,0,0,.4.4h.8a.4.4,0,0,0,.4-.4V5.464H4.419A.4.4,0,0,0,4.7,4.778L2.694,2.368a.4.4,0,0,0-.568,0L.118,4.778A.4.4,0,0,0,.4,5.464ZM7.231,7.071h3.214a.4.4,0,0,0,.4-.4v-.8a.4.4,0,0,0-.4-.4H9.038l1.538-1.769a.8.8,0,0,0,.27-.6V2.652a.4.4,0,0,0-.4-.4H7.231a.4.4,0,0,0-.4.4v.8a.4.4,0,0,0,.4.4H8.637L7.1,5.626a.8.8,0,0,0-.27.6v.443A.4.4,0,0,0,7.231,7.071Zm3.994,5.891L9.736,8.944a.4.4,0,0,0-.378-.267H8.317a.4.4,0,0,0-.378.267L6.451,12.961a.4.4,0,0,0,.378.537h.623a.4.4,0,0,0,.382-.278l.111-.324H9.728l.111.324a.4.4,0,0,0,.383.278h.624a.4.4,0,0,0,.378-.537Zm-2.8-1.472.412-1.205.412,1.205Z",
    transform: "translate(0 -2.25)",
    fill: "#8b9095"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortUp);
export default __webpack_public_path__ + "static/media/sort-up.65ddce45.svg";
export { ForwardRef as ReactComponent };